import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Dropdown,
  Button,
  Checkbox,
  Input
} from 'semantic-ui-react'

const CardSettingAppointmentReminderUX = (props: any) => {
    return(
      <div
        id="CardSettingAppointmentReminderUX-div-0"
        style={{ margin: "15px" }}>
        <div
          id="CardSettingAppointmentReminderUX-div-1"
          style={{padding: "10px 10px 15px", fontSize: "1.2rem", fontWeight: "bold" ,display: "flex", alignItems: "center" }}>
          {props.languageUX === "en" ? "Clinic patient appointment reminder schedule" : "ตารางกำหนดแจ้งเตือนนัดหมายให้ผู้ป่วยของคลินิก"}
        </div>
        <div
          id="CardSettingAppointmentReminderUX-div-2"
          style={{display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          
          <div
            id="CardSettingAppointmentReminderUX-div-51"
            style={{ display: "flex", alignItems:  "center", width: "50%" }}>
            
            <div
              id="CardSettingAppointmentReminderUX-div-53"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </div>
            <Dropdown
              clearable={true}
              id="CardSettingAppointmentReminderUX-Dropdown-54"
              multiple={true}
              onChange={props.handleChangeValue("searchDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              style={{ marginRight: "20px", width: "100%" }}
              value={props.appointmentReminderOrder?.searchDivision}>
            </Dropdown>
            <Button
              color="teal"
              id="CardSettingAppointmentReminderUX-Button-55"
              onClick={props.onSearchAppointmentReminder}
              size="small">
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <div
            id="CardSettingAppointmentReminderUX-div-52">
            
            <Button
              color="green"
              id="CardSettingAppointmentReminderUX-Button-56"
              onClick={props.onOpenAppointmentReminder}
              size="small">
              {props.languageUX === "en" ? "Add queue definition" : "เพิ่มการกำหนดคิว"}
            </Button>
          </div>
        </div>
        <Table
          data={props.appointmentReminderQueue}
          headers="แผนก,จำนวนวันแจ้งยืนยันนัดหมาย (ก่อนกี่วัน),จำนวนชั่วโมงแจ้งยืนยันนัดหมาย (ก่อนกี่ชั่วโมง),แก้ไข,ลบ"
          keys="division,confirmDay,incoming,edit,delete"
          minRows="5"
          showPagination={false}
          style={{height: "300px", marginTop: "0.5rem"}}
          widths="{ ....,...,...,100px,100px }">
        </Table>
        <div
          id="CardSettingAppointmentReminderUX-div-66"
          style={{ margin: "20px 0px", padding: "20px", border:  "1.5px solid rgba(26, 179, 203, 1)", ...(!props.openAppointmentReminder && {display: "none" }) }}>
          
          <div
            id="CardSettingAppointmentReminderUX-div-115"
            style={{width: "100%"}}>
            {props.errorRemind}
          </div>
          <div
            id="CardSettingAppointmentReminderUX-div-67"
            style={{display: "flex", alignItems: "center", width: "55%" }}>
            
            <div
              id="CardSettingAppointmentReminderUX-div-68"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </div>
            <Dropdown
              clearable={true}
              id="CardSettingAppointmentReminderUX-Dropdown-69"
              multiple={true}
              onChange={props.handleChangeValue("selectDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              style={{ marginRight: "20px", width: "70%" , display: props.appointmentReminderOrder?.selectAllDivision && "none"}}
              value={props.appointmentReminderOrder?.selectDivision }>
            </Dropdown>
            <Input
              id="CardSettingAppointmentReminderUX-Input-87"
              readOnly="true"
              style={{ marginRight: "20px", width: "70%" , display: !props.appointmentReminderOrder?.selectAllDivision && "none"}}
              value="ืทั้งหมด">
            </Input>
            <Checkbox
              checked={props.appointmentReminderOrder?.selectAllDivision}
              id="CardSettingAppointmentReminderUX-Checkbox-70"
              label={props.languageUX === "en" ? "All Departments" : "แผนกทั้งหมด"}
              name="selectAllDivision"
              onChange={props.handleChangeSelectAllDivision}>
            </Checkbox>
          </div>
          <div
            id="CardSettingAppointmentReminderUX-div-92"
            style={{display: "flex",  marginTop: "20px", alignItems: "flex-start" }}>
            
            <div
              id="CardSettingAppointmentReminderUX-div-93"
              style={{display: "flex", alignItems: "center", marginTop: "20px" }}>
              
              <label
                id="CardSettingAppointmentReminderUX-label-95"
                style={{ fontWeight: "bold" ,marginRight: "20px" }}>
                {props.languageUX === "en" ? "Number of days to confirm appointment" : "จำนวนวันแจ้งยืนยันนัดหมาย"}
              </label>
              <label
                id="CardSettingAppointmentReminderUX-label-96">
                {props.languageUX === "en" ? "Before the appointment date" : "ก่อนถึงวันนัดหมาย"}
              </label>
              <label
                id="CardSettingAppointmentReminderUX-label-114"
                style={{color:"red",margin: " 0 20px 0 5px"}}>
                *
              </label>
              <Input
                id="CardSettingAppointmentReminderUX-Input-98"
                min="0"
                onChange={props.handleChangeValueConfirmDay}
                style={{ marginRight: "20px" }}
                type="number"
                value={props.appointmentReminderOrder?.confirmDay || 0}>
              </Input>
              <label
                id="CardSettingAppointmentReminderUX-label-97"
                style={{ fontWeight: "bold" ,marginRight: "20px" }}>
                {props.languageUX === "en" ? "day" : "วัน"}
              </label>
              <label
                id="CardSettingAppointmentReminderUX-label-111"
                style={{ fontWeight: "bold" ,marginRight: "20px" }}>
                {props.languageUX === "en" ? "Number of hours confirmed as per appointment" : "จำนวนชั่วโมงแจ้งยืนยันตามนัดหมาย"}
              </label>
              <label
                id="CardSettingAppointmentReminderUX-label-112"
                style={{ marginRight: "20px", whiteSpace: "pre-line", }}>
                {`ก่อนถึงวันนัดหมาย \n(หลังยืนยันแล้ว)`}
              </label>
            </div>
            <div
              id="CardSettingAppointmentReminderUX-div-94"
              style={{display: "flex", marginTop: "20px",  alignItems: "center", }}>
              
              <div
                id="CardSettingAppointmentReminderUX-div-113">
                {props.incomingData}
              </div>
            </div>
          </div>
          <div
            id="CardSettingAppointmentReminderUX-div-101"
            style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
            
            <Button
              color="green"
              id="CardSettingAppointmentReminderUX-Button-102"
              onClick={props.onSaveAppointmentReminder}
              size="small"
              style={{ margin: "0px 10px" }}>
              {props.languageUX === "en" ? "record" : "บันทึก"}
            </Button>
            <Button
              color="red"
              id="CardSettingAppointmentReminderUX-Button-103"
              onClick={props.onCloseAppointmentReminder}
              size="small">
              {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardSettingAppointmentReminderUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Wed Oct 01 2025 11:59:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ตารางกำหนดแจ้งเตือนนัดหมายให้ผู้ป่วยของคลินิก",
          "valueEN": "Clinic patient appointment reminder schedule"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 15px\", fontSize: \"1.2rem\", fontWeight: \"bold\" ,display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 10,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.appointmentReminderQueue"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "แผนก,จำนวนวันแจ้งยืนยันนัดหมาย (ก่อนกี่วัน),จำนวนชั่วโมงแจ้งยืนยันนัดหมาย (ก่อนกี่ชั่วโมง),แก้ไข,ลบ"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "keys": {
          "type": "value",
          "value": "division,confirmDay,incoming,edit,delete"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\", marginTop: \"0.5rem\"}"
        },
        "widths": {
          "type": "value",
          "value": "{ ....,...,...,100px,100px }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems:  \"center\", width: \"50%\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Dropdown",
      "parent": 51,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Dropdown-54"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"searchDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentReminderOrder?.searchDivision"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Button",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Button-55"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchAppointmentReminder"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Button",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มการกำหนดคิว",
          "valueEN": "Add queue definition"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Button-56"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenAppointmentReminder"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"20px 0px\", padding: \"20px\", border:  \"1.5px solid rgba(26, 179, 203, 1)\", ...(!props.openAppointmentReminder && {display: \"none\" }) }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"55%\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Dropdown-69"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"70%\" , display: props.appointmentReminderOrder?.selectAllDivision && \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentReminderOrder?.selectDivision "
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Checkbox",
      "parent": 67,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.appointmentReminderOrder?.selectAllDivision"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Checkbox-70"
        },
        "label": {
          "type": "value",
          "value": "แผนกทั้งหมด",
          "valueEN": "All Departments"
        },
        "name": {
          "type": "value",
          "value": "selectAllDivision"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeSelectAllDivision"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Input",
      "parent": 67,
      "props": {
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Input-87"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"70%\" , display: !props.appointmentReminderOrder?.selectAllDivision && \"none\"}"
        },
        "value": {
          "type": "value",
          "value": "ืทั้งหมด"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  marginTop: \"20px\", alignItems: \"flex-start\" }"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginTop: \"20px\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginTop: \"20px\",  alignItems: \"center\", }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนวันแจ้งยืนยันนัดหมาย",
          "valueEN": "Number of days to confirm appointment"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-label-95"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "ก่อนถึงวันนัดหมาย",
          "valueEN": "Before the appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-label-96"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน",
          "valueEN": "day"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-label-97"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Input",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Input-98"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValueConfirmDay"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentReminderOrder?.confirmDay || 0"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", marginTop: \"20px\" }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Button",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Button-102"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveAppointmentReminder"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Button",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-Button-103"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseAppointmentReminder"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนชั่วโมงแจ้งยืนยันตามนัดหมาย",
          "valueEN": "Number of hours confirmed as per appointment"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-label-111"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": "`ก่อนถึงวันนัดหมาย \\n(หลังยืนยันแล้ว)`"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-label-112"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", whiteSpace: \"pre-line\", }"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": "props.incomingData"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-113"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-label-114"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\",margin: \" 0 20px 0 5px\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorRemind"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingAppointmentReminderUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 67,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardSettingAppointmentReminderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
